<template>
  <div class="change-log-modal">
    <Modal v-model="visible" title="变更记录" width="1000px" @cancel="handleCancel" :footer="null">
      <Table
        :columns="columns"
        :dataSource="dataList"
        size="small"
        bordered
        :pagination="pagination"
        @change="handleTableChange"
      >
        <template #empty>
          <div>暂无变更记录</div>
        </template>
      </Table>
    </Modal>
  </div>
</template>

<script>
import { Modal, Table, Button, Tooltip } from 'ant-design-vue'
import { getAction } from '@/command/netTool'

export default {
  name: 'ChangeLogModal',
  components: {
    Modal,
    Table,
    Button,
    Tooltip,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    resourceId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      dataList: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条记录`,
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          width: 80,
          align: 'center',
          customRender: (text, record, index) => {
            return (this.pagination.current - 1) * this.pagination.pageSize + index + 1
          },
        },
        {
          title: '操作类型',
          dataIndex: 'operateTypeName',
          key: 'operateTypeName',
          align: 'left',
          ellipsis: true,
        },
        {
          title: '操作信息',
          dataIndex: 'operateContent',
          key: 'operateContent',
          align: 'left',
          width: 300,
          customRender: function (text, records) {
            return records.operateContent == null ? (
              ''
            ) : (
              <Tooltip title={records.operateContent} placement="top">
                <div style="max-width: 260px;text-overflow: ellipsis;white-space: nowrap; overflow: hidden;">
                  {records.operateContent}
                </div>
              </Tooltip>
            )
          },
        },
        {
          title: '操作人',
          dataIndex: 'operateUserName',
          key: 'operateUserName',
          align: 'left',
          ellipsis: true,
        },
        {
          title: '操作时间',
          dataIndex: 'operateTime',
          key: 'operateTime',
          align: 'left',
          ellipsis: true,
          width: 170,
        },
      ],
    }
  },
  watch: {
    visible(val) {
      if (val && this.resourceId) {
        this.pagination.current = 1
        this.loadData()
      }
    },
  },
  methods: {
    loadData() {
      const params = {
        housingResourcesId: this.resourceId,
        current: this.pagination.current,
        size: this.pagination.pageSize,
      }
      getAction(`/farmHousingResources/recordPage`, params)
        .then((res) => {
          console.log(res)
          if (res.code == 200) {
            this.dataList = res.data.records || []
            this.pagination.total = res.data.total || 0
          } else {
            console.error('获取变更记录失败:', res.msg)
          }
        })
        .catch((error) => {
          console.error('请求变更记录接口失败:', error)
        })
    },
    handleTableChange(pagination) {
      this.pagination = { ...pagination }
      this.loadData()
    },
    handleCancel() {
      this.$emit('cancel', false)
    },
  },
}
</script>

<style lang="less" scoped>
.change-log-modal {
  .ant-table {
    margin-bottom: 16px;
  }

  .ellipsis-text {
    display: inline-block;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>